/* eslint-disable no-unused-expressions */
function FormValidator() {
  const checks = [];
  const check = (x) => {
    checks.push(x);
  };

  function chain(value, raise) {
    checks.forEach((checkItem) => {
      checkItem(value, raise);
    });
  }

  const isEmpty = (value) => (typeof value === 'undefined' || !value || value.length === 0);

  chain.required = (errorMessage = 'required') => {
    check((value, raise) => {
      isEmpty(value) && raise(errorMessage);
    });
    return chain;
  };

  chain.min = (checkValue, errorMessage = 'min') => {
    check((value, raise) => {
      const numeralValue = Number(value);
      (!isEmpty(value) && numeralValue < checkValue) && raise(errorMessage);
    });
    return chain;
  };

  chain.max = (checkValue, errorMessage = 'max') => {
    check((value, raise) => {
      const numeralValue = Number(value);
      (!isEmpty(value) && numeralValue > checkValue) && raise(errorMessage);
    });
    return chain;
  };

  chain.equal = (checkValue, errorMessage = 'equal') => {
    check((value, raise) => {
      (value !== checkValue) && raise(errorMessage);
    });
    return chain;
  };

  chain.minLen = (checkValue, errorMessage = 'minLen') => {
    check((value, raise) => {
      (!isEmpty(value) && (typeof value.length === 'number' && value.length < checkValue)) && raise(errorMessage);
    });
    return chain;
  };

  chain.maxLen = (checkValue, errorMessage = 'maxLen') => {
    check((value, raise) => {
      (!isEmpty(value) && (typeof value.length === 'number' && value.length > checkValue)) && raise(errorMessage);
    });
    return chain;
  };

  chain.len = (checkValue, errorMessage = 'len') => {
    check((value, raise) => {
      (!isEmpty(value) && (typeof value.length === 'number' && value.length !== checkValue)) && raise(errorMessage);
    });
    return chain;
  };

  chain.startsWith = (startsWith, errorMessage = 'startsWith') => {
    check((value, raise) => {
      (!isEmpty(value) && !value.startsWith(startsWith)) && raise(errorMessage);
    });
    return chain;
  };

  chain.endsWith = (endsWith, errorMessage = 'endsWith') => {
    check((value, raise) => {
      (!isEmpty(value) && !value.endsWith(endsWith)) && raise(errorMessage);
    });
    return chain;
  };

  chain.regexp = (regexpStr, errorMessage = 'regexp') => {
    check((value, raise) => {
      (!isEmpty(value) && !(new RegExp(regexpStr).test(value))) && raise(errorMessage);
    });
    return chain;
  };

  chain.custom = (handler, errorMessage = 'custom') => {
    check((value, raise) => {
      !handler(value) && raise(errorMessage);
    });
    return chain;
  };


  return chain;
}

FormValidator.check = (component) => {
  try {
    const value = typeof component.props.formatter === 'function' ? component.props.formatter(component.props.value) : component.props.value;

    const ret = {
      name: component.props.name,
      ok: true,
      value,
      errors: [],
    };
    if (typeof component.props.validation === 'function') {
      component.props.validation(value, (error) => {
        ret.ok = false;
        ret.errors.push(error);
      });
    }
    return ret;
  } catch (e) {
    throw new Error('Unrecognizable componend!');
  }
};

export default FormValidator;
